import css from "./assets/css/index.css";
import {
  imgsLoaded,
  setBgImg,
  addClass,
  removeClass,
  randomNum,
  Schedule,
  getPolygonsPosition,
  getTargetData,
  getStrLen,
  request,
  audioPlay
} from "./util/";

// 图片引入
import mp3 from './assets/music/BGM.mp3';
import backgroundImg from "./assets/img/loading/background.png";
import startBackgroundImg from "./assets/img/start/background.png";
import startAnswerActionImg from "./assets/img/start/startAnswer.png";
import startAnswerAndAvatorImg from "./assets/img/start/answerAndAvator.png";
import startTextImg from './assets/img/start/text.png';
import circleListImg from "./assets/img/start/cilcleList.png";
import page1BackgroundImg from "./assets/img/page1/background.png";
import page1AnswerListImg from "./assets/img/page1/answerList.png";
import page2BackgroundImg from "./assets/img/page2/background.png";
import page2ColorLineImg from "./assets/img/page2/colorfulLine.png";
import page3BackgroundImg from "./assets/img/page3/background.png";
import page4BackgroundImg from "./assets/img/page4/background.png";
import page4PinImg from "./assets/img/page4/pin.png";
import page4DotImg from "./assets/img/page4/dot.png";
import page5BackgroundImg from "./assets/img/page5/background.png";
import page5ColorLineImg from "./assets/img/page5/colorLine.png";
import page6BackgroundImg from "./assets/img/page6/background.png";
import page6CircleImg from "./assets/img/page6/circleList.png";
import page7BackgroundImg from "./assets/img/page7/background.png";
import page7colorShapeImg from "./assets/img/page7/colorShape.png";
import page8BackgroundImg from "./assets/img/page8/background.png";
import page8RoateAnimationImg from "./assets/img/page8/roateAnimation.png";
import page9BackgroundImg from "./assets/img/page9/background.png";
import page9ProgressImg from "./assets/img/page9/progress.png";
import page9ProgressBgImg from "./assets/img/page9/progress-bg.png";
import page9WrapAnimationImg from "./assets/img/page9/wrapAnimation.png";
import page9HandImg from "./assets/img/page9/hand.png";
import page10BackgroundImg from "./assets/img/page10/background.png";
import page10CatSvg from "./assets/img/page10/cat.svg";
import pageInputBackgroundImg from "./assets/img/input/background.png";
import pageGeneratingColorLineImg from "./assets/img/generating/colorLine.png";
import pageGeneratingBgImg from "./assets/img/generating/background.png";
import pageGeneratingTextImg from './assets/img/generating/generatingText.png';
import shareBackgroundImg from "./assets/img/share/background.png";
import shareRadarCircleImg from "./assets/img/share/radarCircle.png";
import shareRadarCircleLabelImg from "./assets/img/share/radarText.png";
import imgDefaultAvator from "./assets/img/share/userAvator.jpg";
import shareCodeImg from "./assets/img/share/code.png";

const {
  href: HREF,
  origin: ORIGIN,
  pathname: PATHNAME,
  search: SEARCH
} = location;
let userAvatorUrl = "";
let pathArr = PATHNAME.split("/");
pathArr.splice(pathArr.length - 1, "");
const path = pathArr.join("/");

document.addEventListener("WeixinJSBridgeReady", function onBridgeReady() {
  WeixinJSBridge.call("hideToolbar");
});

// 分享页设定
ydk.config({
  debug: false,
  jsApiList: ["share"]
});

console.log("分享页图片位置", `${ORIGIN}${path}${imgDefaultAvator}`);
console.log("分享连接", `${ORIGIN}${path}?time=${new Date().getTime()}`);

ydk.share({
  silence: true,
  title: "测测你的人格关键词",
  desc: "发现未知的自己",
  imgUrl: `${ORIGIN}${path}${imgDefaultAvator}`,
  link: `${ORIGIN}${path}?time=${new Date().getTime()}`
});

// 微信登录
if (/MicroMessenger/gi.test(navigator.userAgent)) {
  const [
    [, isLogin]
  ] = SEARCH.substr(1)
    .split("&")
    .map(v => v.split("="));

  if (!!isLogin) {
    function checkStatus(res) {
      res = JSON.parse(res);
      console.log("响应拦截", res);
      return res;
    }
    request("http://dict.youdao.com/login/acc/co/cq?product=DICT&cf=1", {
        credentials: "include"
      })
      .then(checkStatus)
      .then(res => {
        if (res.login) {
          userAvatorUrl = res["imageurl"];
        }
      });
  } else {
    const tp = "weixin-mp-yd";
    const href = HREF + `?isLogin=1`;
    window.location.replace(
      `http://dict.youdao.com/login/acc/login?app=web&product=DICT&tp=${tp}&fr=1&cf=7&ru=${encodeURIComponent(
        href
      )}`
    );
  }
}

let inputValue = "";
const pageScore = {}; // 成绩缓存
const pageScoreStandardValMap = {
  open: 3.16,
  nervousness: 3,
  pleasant: 3.83,
  conscientiousness: 3.16,
  extroversion: 3.5
};

const typeOrder = [
  "pleasant",
  "nervousness",
  "extroversion",
  "open",
  "conscientiousness"
];
const shareBackgroundImgBaseUrl = "./assets/img/share/bgs/";
const shareTipsImgBaseUrl = "./assets/img/share/tips/";

const pageScoreBgImgNumer = {};
const pageScoreTipsImgNumer = {};

const pageScoreBgImgsContext = require.context('./assets/img/share/bgs', true, /\.png$/);
const pageScoreTipsImgsContext = require.context('./assets/img/share/tips', true, /\.png$/);

pageScoreBgImgsContext.keys().forEach(imgUrl => {
  const [, type, scoreAndNo] = imgUrl.split('/')
  const [score] = scoreAndNo.split('-');

  if (!pageScoreBgImgNumer[type]) {
    pageScoreBgImgNumer[type] = {};
  }
  pageScoreBgImgNumer[type][score] = !pageScoreBgImgNumer[type][score] ? 1 : ++pageScoreBgImgNumer[type][score];
})

pageScoreTipsImgsContext.keys().forEach(imgUrl => {
  const [, type, scoreAndNo] = imgUrl.split('/')
  const [score] = scoreAndNo.split('-');
  if (!pageScoreTipsImgNumer[type]) {
    pageScoreTipsImgNumer[type] = {};
  }
  pageScoreTipsImgNumer[type][score] = !pageScoreTipsImgNumer[type][score] ? 1 : ++pageScoreTipsImgNumer[type][score];
})

console.log(pageScoreBgImgNumer, pageScoreTipsImgNumer)

const sharePageLevel2Img = {
  conscientiousness: "./assets/img/share/level2/conscientiousness.png",
  extroversion: "./assets/img/share/level2/extroversion.png",
  nervousness: "./assets/img/share/level2/nervousness.png",
  open: "./assets/img/share/level2/open.png",
  pleasant: "./assets/img/share/level2/pleasant.png"
};

const querySelector = document.querySelector.bind(document);
const querySelectorAll = document.querySelectorAll.bind(document);
// dom缓存
const activity = querySelector("#activity");
const loading = querySelector("#loading");
const music = document.getElementById('music');
const start = querySelector("#start");
const page1 = querySelector("#page1");
const page2 = querySelector("#page2");
const page3 = querySelector("#page3");
const page4 = querySelector("#page4");
const page5 = querySelector("#page5");
const page6 = querySelector("#page6");
const page7 = querySelector("#page7");
const page8 = querySelector("#page8");
const page9 = querySelector("#page9");
const page10 = querySelector("#page10");
const pageInput = querySelector("#pageInput");
const pageGenerating = querySelector("#generating")
const share = querySelector("#share");

const loadingProgress = querySelector('#loading .progress .progress-container');
const loadingProgressText = querySelector('#loading .progress-text');

const startAction = querySelector("#start .action");
const startItemAvator1 = querySelector("#start .answer-list .answer-1 .avator");
const startItemCircle1 = querySelector("#start .answer-list .answer-1 .circle");
const startItemAvator2 = querySelector("#start .answer-list .answer-2 .avator");
const startItemCircle2 = querySelector("#start .answer-list .answer-2 .circle");
const startItemAvator3 = querySelector("#start .answer-list .answer-3 .avator");
const startItemCircle3 = querySelector("#start .answer-list .answer-3 .circle");
const startText = querySelector('#start .text')

const page1AnswerList = querySelector("#page1 .answer-list");

const [page1Answer1, page1Answer2, page1Answer3] = querySelectorAll(
  "#page1 .answer-list .answer-item"
);

const page2ColorLine = querySelector("#page2 .color-line");
const page2ColorLineWord = querySelector("#page2 .color-line .line-word");

const page2AnswerList = querySelector("#page2 .answer-list");

const page3AnswerList = querySelector("#page3 .answer-list");

const page4Pin = querySelector("#transformAnimation5 .pin");
const page4Dot = querySelector("#page4 .dot");
const page4AnswerList = querySelector("#page4 .answer-list");

const page5AnswerList = querySelector("#page5 .answer-list");
const page5ColorLine = querySelector("#page5 .color-line");

const page6ColorCircle = querySelector("#page6 .color-circle");
const page6ColorRound = querySelector("#page6 .color-circle .color-round");
const page6RoundTop = querySelector("#page6 .round-top");
const page6RoundBottom = querySelector("#page6 .round-bottom");
const page6AnswerList = querySelector("#page6 .answer-list");

const page7ColorHalfCicle = querySelector("#page7 .color-half-circle");
const page7ColorSquare = querySelector("#page7 .color-square");
const page7AnswerList = querySelector("#page7 .answer-list");

const page8AnswerList = querySelector("#page8 .answer-list");

const pageProgress = querySelector("#page9 .dragger-progress");
const page9DraggerBarProgressBg = querySelector(
  "#page9 .dragger-progress .dragger-bar-bg"
);
const page9DraggerBarProgress = querySelector(
  "#page9 .dragger-progress .dragger-bar"
);
const page9Hand = querySelector("#page9 .dragger-progress-hand");
const page9DraggerBarProgressVal = querySelector(
  "#page9 .dragger-progress .dragger-val .dragger-val-number"
);

const page10AnswerList = querySelector("#page10 .answer-list");
const page10CatSvgImg = querySelector("#page10 .cat");

const pageInputName = querySelector("#pageInput .name");
const pageInputAction = querySelector("#pageInput .action");

const pageGeneratingColorLine = querySelector("#generating .color-line");
const pageGeneratingText = querySelector('#generating .generating-text');

const shareImg = querySelector("#share #shareImg");
const sharePageLevel2 = querySelector("#share .level-2");
const sharePageLevel2Return = querySelector("#share .level-2 .return");
const radarScoreCanvas = document.createElement("canvas");
radarScoreCanvas.width = 750;
radarScoreCanvas.height = 1334;

const transformAnimation1 = querySelector("#transformAnimation1");
const transformAnimation2 = querySelector("#transformAnimation2");
const transformAnimation3 = querySelector("#transformAnimation3");
const transformAnimation4 = querySelector("#transformAnimation4");
const transformAnimation5 = querySelector("#transformAnimation5");
const transformAnimation6 = querySelector("#transformAnimation6");
const transformAnimation7 = querySelector("#transformAnimation7");
// const transformAnimation8 = querySelector('#transformAnimation8');
const transformAnimation9 = querySelector("#transformAnimation9");
const transformAnimation10 = querySelector("#transformAnimation10");
const transformAnimation11 = querySelector("#transformAnimation11");

// 图片缓存
const backgroundImgCache = new Image();
const startBackgroundImgCache = new Image();
const startAnswerActionImgCache = new Image();
const startAnswerAndAvatorImgCache = new Image()
const startTextImgCache = new Image();
const circleListImgCache = new Image();

const page1BackgroundImgCache = new Image();
const page1AnswerListImgCache = new Image();

const page2BackgroundImgCache = new Image();
const page2ColorLineImgCache = new Image();

const page3BackgroundImgCache = new Image();

const page4BackgroundImgCache = new Image();
const page4PinImgCache = new Image();
const page4DotImgCache = new Image();

const page5BackgroundImgCache = new Image();
const page5ColorLineImgCache = new Image();

const page6BackgroundImgCache = new Image();
const page6CircleImgCache = new Image();

const page7BackgroundImgCache = new Image();
const page7colorShapeImgCache = new Image();

const page8BackgroundImgCache = new Image();
const page9BackgroundImgCache = new Image();
const page8RoateAnimationImgCache = new Image();

const page9ProgressImgCache = new Image();
const page9ProgressBgImgCache = new Image();
const page9WrapAnimationImgCache = new Image();
const page9HandImgCache = new Image();

const page10BackgroundImgCache = new Image();
const page10CatSvgCache = new Image();

const pageInputBackgroundImgCache = new Image();

const pageGeneratingColorLineImgCache = new Image();
const pageGeneratingBgImgCache = new Image();
const pageGeneratingTextImgCache = new Image();

const shareBackgroundImgCache = new Image();
const shareRadarCircleImgCache = new Image();
const shareRadarCircleLabelImgCache = new Image();
const shareCodeImgCache = new Image();
const userAvatorImgCache = new Image();
userAvatorImgCache.setAttribute("crossOrigin", "Anonymous");

backgroundImgCache.src = backgroundImg;

music.src = mp3;
audioPlay.init(music);

imgsLoaded([backgroundImgCache]).then(() => {
  setBgImg([loading], [backgroundImg]);

  const imgs = [
    startBackgroundImg,
    startAnswerActionImg,
    startAnswerAndAvatorImg,
    startTextImg,
    circleListImg,
    page1BackgroundImg,
    page1AnswerListImg,
    page2BackgroundImg,
    page2ColorLineImg,
    page3BackgroundImg,
    page4BackgroundImg,
    page4PinImg,
    page4DotImg,
    page5BackgroundImg,
    page6BackgroundImg,
    page6CircleImg,
    page7BackgroundImg,
    page8BackgroundImg,
    page7colorShapeImg,
    page8RoateAnimationImg,
    page9BackgroundImg,
    page10BackgroundImg,
    shareBackgroundImg,
    shareRadarCircleImg,
    shareRadarCircleLabelImg,
    page9ProgressImg,
    page9ProgressBgImg,
    page9HandImg,
    page5ColorLineImg,
    page9WrapAnimationImg,
    page10CatSvg,
    pageInputBackgroundImg,
    pageGeneratingColorLineImg,
    pageGeneratingBgImg,
    pageGeneratingTextImg,
    shareCodeImg
  ];
  const imgCaches = [
    startBackgroundImgCache,
    startAnswerActionImgCache,
    startAnswerAndAvatorImgCache,
    startTextImgCache,
    circleListImgCache,
    page1BackgroundImgCache,
    page1AnswerListImgCache,
    page2BackgroundImgCache,
    page2ColorLineImgCache,
    page3BackgroundImgCache,
    page4BackgroundImgCache,
    page4PinImgCache,
    page4DotImgCache,
    page5BackgroundImgCache,
    page6BackgroundImgCache,
    page6CircleImgCache,
    page7BackgroundImgCache,
    page8BackgroundImgCache,
    page8RoateAnimationImgCache,
    page7colorShapeImgCache,
    page9BackgroundImgCache,
    page10BackgroundImgCache,
    shareBackgroundImgCache,
    shareRadarCircleImgCache,
    shareRadarCircleLabelImgCache,
    page9ProgressImgCache,
    page9ProgressBgImgCache,
    page9HandImgCache,
    page5ColorLineImgCache,
    page9WrapAnimationImgCache,
    page10CatSvgCache,
    pageInputBackgroundImgCache,
    pageGeneratingColorLineImgCache,
    pageGeneratingBgImgCache,
    pageGeneratingTextImgCache,
    shareCodeImgCache
  ];

  imgCaches.forEach((v, k) => (v.src = imgs[k]));

  let rainDropDotTimer, rainDropLineTimer;

  let timeoutPromise = new Promise(resolve => {
    setTimeout(() => {
      resolve()
    }, 3000)
  })

  Promise.all([
    timeoutPromise,
    imgsLoaded(imgCaches, function (progress) {
      loadingProgress.style.width = progress * 100 + '%';
      loadingProgressText.innerHTML = parseInt((progress * 100)) + '%';
      console.log("progress", progress);
    })
  ]).then(() => {
    console.log('all load');
    addAllEvent();
    // 隐藏 loading页面 开始
    const schedule = Schedule(
      [
        [
          function () {
            pageHidden(loading);
            setStartPageBg();
            pageShow(start);
            setTimeout(() => {
              startPageAvatorAnimationStart(); // 800ms
            }, 100);
          }
        ],
        [
          function () {
            setPage1Bg();
            pageShow(page1);
            animationStart(transformAnimation1, 800); // 800
            pageHidden(start);
            setTimeout(() => {
              page2PageAnswerAnimationStart();
            }, 100);
          }
        ],
        [
          function () {
            setPage2Bg();
            pageShow(page2);
            animationStart(transformAnimation2, 0); // 800ms
            setTimeout(() => {
              pageHidden(page1);
            }, 1500);
          },
          1000
        ],
        [
          function () {
            setPage3Bg();
            pageShow(page3);
            animationStart(transformAnimation3, 800);
          },
          1000
        ],
        [
          function () {
            setPage4Bg();
            pageHidden(page2);
            animationEnd(transformAnimation2);
            pageShow(page4);
            animationStart(transformAnimation4, 0);
            setTimeout(() => {
              pageHidden(page3);
            }, 1000);
          },
          1000
        ],
        [
          function () {
            setPage5Bg();
            pageShow(page5);
            animationStart(transformAnimation5, 500, function () {
              animationEnd(transformAnimation4);
            });
          },
          1000
        ],
        [
          function () {
            setPage6Bg();
            pageShow(page6);
            animationStart(transformAnimation6, 0);
          },
          1000
        ],
        [
          function () {
            setPage7Bg();
            pageShow(page7);
            animationStart(transformAnimation7, 1000, function () {
              animationEnd(transformAnimation6);
            });
          },
          1000
        ],
        [
          function () {
            setPage8Bg();
            animationStart(transformAnimation9, 1500, function () {
              rainDropDotTimer = rainDropLineAnimationStart(page8);
              rainDropLineTimer = rainDropDotAnimationStart(page8);
            });
            setTimeout(() => {
              pageShow(page8);
              pageHidden(page7);
            }, 100);
          },
          1000
        ],
        [
          function () {
            setPage9Bg();
            pageShow(page9);
            clearInterval(rainDropDotTimer);
            clearInterval(rainDropLineTimer);
            pageHidden(page8);
            setTimeout(() => {
              addClass(page9Hand, "active");
            });
          },
          1000
        ],
        [
          function () {
            setPage10Bg();
            animationStart(transformAnimation10, 1500, function () {
              page10CatSvgImg.src = page10CatSvg;
              page10CatSvgImg.style.display = "block";
            });
            setTimeout(() => {
              pageShow(page10);
              pageHidden(page9);
            }, 100);
          },
          1000
        ],
        [
          function () {
            setPageInputBg();
            pageShow(pageInput);
            pageHidden(page10);
          }
        ],
        [
          function () {
            setPageGeneratingBg();
            pageShow(pageGenerating);
            pageHidden(pageInput);
            setTimeout(() => {
              schedule.next()
            }, 2000)
          }
        ],
        [
          function () {
            setShareBg();

            const scoreMap = getScore();
            const scoreBgList = [];
            const scoreList = [];

            for (let k of Object.keys(scoreMap)) {
              scoreList.push(scoreMap[k]);
              scoreBgList.push({
                standardVal: Math.abs(scoreMap[k] - pageScoreStandardValMap[k]),
                type: k
              });
            }

            scoreBgList.sort((a, b) => {
              let flag = b.standardVal - a.standardVal;
              if (flag === 0) {
                flag = typeOrder.indexOf(b.type) - typeOrder.indexOf(a.type);
              }
              return flag;
            });

            console.log(scoreMap, scoreList, scoreBgList)

            const [{
                type: firstType
              },
              {
                type: secondType
              },
              {
                type: lastType
              }
            ] = scoreBgList;

            const firstScore = scoreMap[firstType];
            const secondScore = scoreMap[secondType];
            const lastScore = scoreMap[lastType];

            const bgMaxNumber = pageScoreBgImgNumer[firstType][firstScore] || 0;
            const tip1MaxNumber =
              pageScoreTipsImgNumer[secondType][secondScore] || 0;
            const tip2MaxNumber = pageScoreTipsImgNumer[lastType][lastScore] || 0;

            const bgNo =
              bgMaxNumber > 0 ?
              bgMaxNumber > 1 ?
              parseInt(randomNum(1, bgMaxNumber)) :
              1 :
              0;
            const tip1No =
              tip1MaxNumber > 0 ?
              tip1MaxNumber > 1 ?
              parseInt(randomNum(1, tip1MaxNumber)) :
              1 :
              0;
            const tip2No =
              tip2MaxNumber > 0 ?
              tip2MaxNumber > 1 ?
              parseInt(randomNum(1, tip2MaxNumber)) :
              1 :
              0;

            console.log(
              `${shareBackgroundImgBaseUrl}${firstType}/${firstScore}-${bgNo}.png`,
              `${shareTipsImgBaseUrl}${secondType}/${secondScore}-${tip1No}.png`,
              `${shareTipsImgBaseUrl}${lastType}/${lastScore}-${tip2No}.png`
            );
            const bgImgCache = new Image();
            const tip1ImgCache = new Image();
            const tip2ImgCache = new Image();

            try {
              let bgUrl = require(`${shareBackgroundImgBaseUrl}${firstType}/${firstScore}-${bgNo}.png`);
              let tip1Url = require(`${shareTipsImgBaseUrl}${secondType}/${secondScore}-${tip1No}.png`);
              let tip2Url = require(`${shareTipsImgBaseUrl}${lastType}/${lastScore}-${tip2No}.png`);

              bgImgCache.src = bgUrl;
              tip1ImgCache.src = tip1Url;
              tip2ImgCache.src = tip2Url;
              userAvatorImgCache.src = userAvatorUrl || imgDefaultAvator;
              try {
                imgsLoaded([
                  bgImgCache,
                  tip1ImgCache,
                  tip2ImgCache,
                  userAvatorImgCache
                ]).then(() => {
                  console.log(
                    bgImgCache,
                    tip1ImgCache,
                    tip2ImgCache,
                    userAvatorImgCache
                  );
                  drawScore(
                    radarScoreCanvas.getContext("2d"),
                    scoreList,
                    bgImgCache,
                    [tip1ImgCache, tip2ImgCache],
                    inputValue,
                    userAvatorImgCache
                  );
                  const data = radarScoreCanvas.toDataURL("image/png");
                  shareImg.crossOrigin = "Anonymous";
                  shareImg.src = data;
                  animationStart(transformAnimation11, 800);
                  pageShow(share);
                  pageHidden(pageGenerating);
                });
              } catch (error) {
                alert(error.message);
              }
            } catch (error) {
              console.log(error.message)
            }
          }
        ]
      ],
      true
    );

    function addAllEvent() {
      startAction.addEventListener("click", () => {
        schedule.next();
      });

      page1AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page1", parseInt(score));
          schedule.next();
        }
      });

      page2AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page2", parseInt(score));
          schedule.next();
        }
      });

      page3AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page3", parseInt(score));
          schedule.next();
        }
      });

      page4AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page4", parseInt(score));
          schedule.next();
        }
      });

      page5AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page5", parseInt(score));
          schedule.next();
        }
      });

      page6AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page6", parseInt(score));
          schedule.next();
        }
      });

      page7AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page7", parseInt(score));
          schedule.next();
        }
      });

      page8AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page8", parseInt(score));
          schedule.next();
        }
      });

      let handProgressStart = 0;
      let progressWidth = 0;
      let handProgressEnd = 0;
      let nowTranslateX = 0;
      let isMove = false;

      pageProgress.addEventListener("touchstart", e => {
        const {
          clientX
        } = e.changedTouches[0];
        progressWidth = page9DraggerBarProgress.clientWidth;
        handProgressStart = clientX;
      });

      pageProgress.addEventListener("touchmove", e => {
        isMove = true;
        const {
          clientX
        } = e.changedTouches[0];
        handProgressEnd = clientX;
        let translateX =
          ((handProgressEnd - handProgressStart) / progressWidth +
            nowTranslateX) *
          100;
        if (translateX >= 100) {
          translateX = 100;
        }
        if (translateX <= 0) {
          translateX = 0;
        }
        page9DraggerBarProgressVal.innerHTML = parseInt(translateX);
        page9DraggerBarProgress.style.transform = `translateX(${translateX}%)`;
      });

      pageProgress.addEventListener("touchend", e => {
        if (isMove) {
          const {
            clientX
          } = e.changedTouches[0];
          handProgressEnd = clientX;
          nowTranslateX =
            (handProgressEnd - handProgressStart) / progressWidth +
            nowTranslateX;
          let translateX = nowTranslateX * 100;
          if (translateX >= 100) {
            translateX = 100;
          }
          if (translateX <= 0) {
            translateX = 0;
          }
          page9DraggerBarProgress.style.transform = `translateX(${translateX}%)`;
          let score = 1;
          score += translateX >= 60 ? Math.ceil((translateX - 60) / 10) : 0;
          addScore("page9", score);
          setTimeout(() => {
            schedule.next();
          }, 300);
          isMove = false;
        }
      });

      page10AnswerList.addEventListener("click", e => {
        const {
          index,
          score
        } = getTargetData(e);
        if (index > 0) {
          addScore("page10", parseInt(score));
          schedule.next();
        }
      });

      pageInputName.addEventListener("change", e => {
        inputValue = pageInputName.value;
      });

      pageInputName.addEventListener("blur", e => {
        window.scrollTo(0, 0);
      });

      pageInputAction.addEventListener("click", e => {
        if (getStrLen(inputValue) > 8) {
          alert("最多输入四个字");
        } else {
          schedule.next();
        }
      });

      share.addEventListener("click", e => {
        const {
          type
        } = getTargetData(e);
        if (type) {
          const level2img = new Image();
          level2img.src = require(sharePageLevel2Img[type] + "");
          imgsLoaded([level2img]).then(res => {
            setBgImg(sharePageLevel2, level2img.src);
            removeClass(sharePageLevel2, "hidden");
          });
        }
      });

      sharePageLevel2Return.addEventListener("click", () => {
        addClass(sharePageLevel2, "hidden");
      });
    }
  });
});

function pageShow(dom) {
  removeClass(dom, "hidden");
}

function pageHidden(dom) {
  addClass(dom, "hidden");
}

function setStartPageBg() {
  setBgImg([start, startAction, startText], [startBackgroundImg, startAnswerActionImg, startTextImg]);
  [
    startItemAvator1,
    startItemAvator2,
    startItemCircle2,
    startItemAvator3,
  ].forEach(v => setBgImg(v, startAnswerAndAvatorImg));
  [startItemCircle1, startItemCircle2, startItemCircle3].forEach(v =>
    setBgImg(v, circleListImg)
  );
}

function startPageAvatorAnimationStart() {
  addClass([startItemAvator1, startItemAvator2, startItemAvator3], "active");
}

function page2PageAnswerAnimationStart() {
  addClass([page1Answer1, page1Answer2, page1Answer3], "active");
}

function setPage1Bg() {
  removeClass(transformAnimation2, "hidden");
  setBgImg(
    [page1, page1Answer1, page1Answer2, page1Answer3],
    [
      page1BackgroundImg,
      page1AnswerListImg,
      page1AnswerListImg,
      page1AnswerListImg
    ]
  );
}

function setPage2Bg() {
  removeClass(transformAnimation3, "hidden");
  setBgImg(
    [page2, page2ColorLine, page2ColorLineWord],
    [page2BackgroundImg, page2ColorLineImg, page2ColorLineImg]
  );
}

function setPage3Bg() {
  removeClass(transformAnimation4, "hidden");
  setBgImg([page3], [page3BackgroundImg]);
}

function setPage4Bg() {
  removeClass(transformAnimation5, "hidden");
  setBgImg(
    [page4, page4Pin, page4Dot],
    [page4BackgroundImg, page4PinImg, page4DotImg]
  );
}

function setPage5Bg() {
  removeClass(transformAnimation6, "hidden");
  removeClass(transformAnimation7, "hidden");
  setBgImg([page5, page5ColorLine], [page5BackgroundImg, page5ColorLineImg]);
}

function setPage6Bg() {
  setBgImg(
    [page6, page6ColorCircle, page6ColorRound, page6RoundTop, page6RoundBottom],
    [
      page6BackgroundImg,
      page6CircleImg,
      page6CircleImg,
      page6CircleImg,
      page6CircleImg
    ]
  );
}

function setPage7Bg() {
  setBgImg(
    [page7, page7ColorHalfCicle, page7ColorSquare],
    [page7BackgroundImg, page7colorShapeImg, page7colorShapeImg]
  );
}

function setPage8Bg() {
  setBgImg(
    [page8, transformAnimation9],
    [page8BackgroundImg, page8RoateAnimationImg]
  );
}

function setPage9Bg() {
  setBgImg(
    [
      page9,
      page9DraggerBarProgressBg,
      page9DraggerBarProgress,
      page9Hand,
      transformAnimation10
    ],
    [
      page9BackgroundImg,
      page9ProgressImg,
      page9ProgressBgImg,
      page9HandImg,
      page9WrapAnimationImg
    ]
  );
}

function setPage10Bg() {
  setBgImg([page10], [page10BackgroundImg]);
}

function setPageInputBg() {
  setBgImg(
    [pageInput],
    [pageInputBackgroundImg]
  );
}

function setPageGeneratingBg() {
  setBgImg(
    [pageGenerating, pageGeneratingColorLine, pageGeneratingText],
    [pageGeneratingBgImg, pageGeneratingColorLineImg, pageGeneratingTextImg]
  );
}

function setShareBg() {
  // removeClass(transformAnimation11, 'hidden');
  // setBgImg([share], [shareBackgroundImg])
}

function addScore(type, score) {
  pageScore[type] = score;
  console.log(pageScore, type);
}

function getScore() {
  const {
    page1,
    page2,
    page3,
    page4,
    page5,
    page6,
    page7,
    page8,
    page9,
    page10
  } = pageScore;
  return {
    extroversion: (page2 + page5) / 2,
    open: (page1 + page3) / 2,
    conscientiousness: (page6 + page9) / 2,
    pleasant: (page4 + page7) / 2,
    nervousness: (page8 + page10) / 2
  };
}

function generateRainDropDot() {
  let rainDrop = document.createElement("div");
  const v = 2;
  const size = `${randomNum(10, 30) / 100}rem`;
  const x = `${randomNum(10, 65) / 10}rem`;
  const duration = randomNum(1000, 2000) / 1000;
  rainDrop.className = "rain-drop dot";
  rainDrop.style.height = size;
  rainDrop.style.width = size;
  rainDrop.style.left = x;
  rainDrop.style.top = "-0.3rem";
  rainDrop.style.opacity = 1;
  rainDrop.style.transform = "translateZ(0)";
  rainDrop.style.transition = `top ${duration}s linear, opacity ${duration *
    0.2}s  ${duration * 0.8}s linear`;
  return {
    el: rainDrop,
    size,
    duration,
    v,
    x,
    start(cb) {
      rainDrop.style.top = v * duration + "rem";
      rainDrop.style.opacity = 0;
      setTimeout(cb, duration * 1000);
    }
  };
}

function generateRainDropLine() {
  let rainDrop = document.createElement("div");
  const v = 1;
  const height = `${randomNum(80, 120) / 100}rem`;
  const x = `${randomNum(10, 65) / 10}rem`;
  const duration = randomNum(1000, 2000) / 1000;
  rainDrop.className = "rain-drop line";
  rainDrop.style.height = height;
  rainDrop.style.left = x;
  rainDrop.style.top = `-${height}`;
  rainDrop.style.opacity = 1;
  rainDrop.style.transform = "translateZ(0)";
  rainDrop.style.transition = `top ${duration}s linear, opacity ${duration *
    0.2}s  ${duration * 0.8}s linear`;
  return {
    el: rainDrop,
    height,
    duration,
    v,
    x,
    start(cb) {
      rainDrop.style.top = v * duration + "rem";
      rainDrop.style.opacity = 0;
      setTimeout(cb, duration * 1000);
    }
  };
}

function rainDropDotAnimationStart(container, time = 800) {
  return setInterval(function () {
    let rainDrop = generateRainDropDot();
    container.appendChild(rainDrop.el);
    setTimeout(function () {
      rainDrop.start(function () {
        container.removeChild(rainDrop.el);
        rainDrop = null;
      });
    }, 100);
  }, time);
}

function rainDropLineAnimationStart(container, time = 1400) {
  return setInterval(function () {
    let rainDrop = generateRainDropLine();
    container.appendChild(rainDrop.el);
    setTimeout(function () {
      rainDrop.start(function () {
        container.removeChild(rainDrop.el);
        rainDrop = null;
      });
    }, 100);
  }, time);
}

function animationStart(animation, time = 0, cb) {
  removeClass(animation, "hidden");
  setTimeout(() => {
    addClass(animation, "active");
  });
  time > 0 &&
    setTimeout(() => {
      animationEnd(animation);
      cb && cb();
    }, time);
}

function animationEnd(animation) {
  addClass(animation, "hidden");
}

function drawScore(ctx, score = [], bg, tips, userName, userAvator) {
  if (!userName) {
    userName = "我";
  }
  console.log("userName", userName);
  const shareRadarCircleImgX = 248;
  const shareRadarCircleImgY = 299;
  const shareRadarLabelImgX = 165;
  const shareRadarLabelImgY = 245;
  const shareTipsImgX = 78;
  const shareTipsImgY = 991;
  const shareTipsImgHeight = 69;
  const shareTipsImgMarginTop = 30;
  const shareUserAvatorX = 112;
  const shareUserAvatorY = 130;

  ctx.drawImage(bg, 0, 0, 750, 1334);
  ctx.drawImage(
    shareRadarCircleLabelImgCache,
    shareRadarLabelImgX,
    shareRadarLabelImgY,
    443,
    349
  );
  ctx.drawImage(
    shareRadarCircleImgCache,
    shareRadarCircleImgX,
    shareRadarCircleImgY,
    264,
    264
  );
  ctx.drawImage(userAvator, shareUserAvatorX, shareUserAvatorY, 84, 84);
  ctx.drawImage(shareCodeImgCache, 593, 1178, 100, 100);
  tips.forEach((v, k) => {
    ctx.drawImage(
      v,
      shareTipsImgX,
      shareTipsImgY + k * (shareTipsImgHeight + shareTipsImgMarginTop),
      v.width,
      v.height
    );
  });

  ctx.textAlign = "center";
  ctx.font = "normal normal 30px arial";
  ctx.fillStyle = "#ffffff";
  ctx.fillText(userName, 350, 184, 86);

  ctx.lineWidth = 2;
  ctx.strokeStyle = "white";
  ctx.lineJoin = "round";
  ctx.beginPath();
  const centerX = shareRadarCircleImgX + 132;
  const centerY = shareRadarCircleImgY + 132;
  score.forEach((v, k) => {
    const raidus = 132 * (v / 5);
    const {
      x,
      y
    } = getPolygonsPosition(centerX, centerY, raidus, 5, k);
    ctx.lineTo(x, y);
  });
  ctx.closePath();
  ctx.stroke();
}